/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Shop_Chip_Remove_AriaInputs */

const vi_shop_chip_remove_aria = /** @type {(inputs: Shop_Chip_Remove_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bỏ ${i?.name}`)
};

/**

* @param {Shop_Chip_Remove_AriaInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_chip_remove_aria = /** @type {((inputs: Shop_Chip_Remove_AriaInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Chip_Remove_AriaInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_chip_remove_aria(inputs)
});